import { FaHandshakeSimple } from 'react-icons/fa6';
import { IoChevronBack } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import HSButton from '../../../../common/Button';
import Loader from '../../../../common/Loader';
import ExistingTeamMember from '../TeamManagement/components/ExistingTeamMember';

type Props = {
    setConfirmation: (f: boolean) => void;
};
const ProfileConfirmation: React.FC<Props> = ({ setConfirmation }) => {
    const teamList = useSelector((state: RootState) => state.teamManagement.teamMemberList);
    const loading = useSelector((state: RootState) => state.teamManagement.loading);

    return (
        <div>
            {!loading && (
                <>
                    <div className="absolute z-30 left-0 bg-[#f5f4f2] top-[-48px]">
                        <HSButton
                            type="link"
                            title="Back"
                            className="uppercase pl-0 text-base"
                            style={{ color: '#1B3E8C' }}
                            onClick={() => {
                                setConfirmation(false);
                            }}
                            icon={<IoChevronBack />}
                        />
                    </div>
                    <div className="p-3 px-2 border border-[#27AE60] bg-[#ffff] text-[#0F2240] flex gap-2 items-center mb-2">
                        <FaHandshakeSimple size="2rem" color="27AE60" />{' '}
                        <p className="!font-[Lato]">
                            <b>Congratulations!</b> You have successfully added the following users to your team
                            account. Please follow instructions below to proceed.
                        </p>
                    </div>

                    {teamList.members.length ? (
                        <div className=" mb-2 w-full">
                            <ExistingTeamMember
                                isConfirm
                                title="Invitations"
                                existingTeamMemberList={teamList.members}
                                showAction={false}
                                showTitle={true}
                            />
                        </div>
                    ) : null}
                    <p className="page_title_onboarding">Information</p>
                    <p className="text-justify mb-4">
                        Account activation emails have been sent to the email addresses noted above. Please follow
                        instructions in the email to create investor accounts and access team data. These users will
                        have the same account type as the team admin account.
                    </p>

                    <p className="text-justify mb-4">
                        Investor information such as profile info, accreditation and KYC information and investment
                        preferences must be consolidated in a team account. As the team admin, the information that you
                        submit in the following steps will represent the team. All previously submitted information by
                        existing team members will be overridden.
                    </p>
                    <p className="text-justify !font-[Lato] text-xs">
                        Note: The account associated with your email address with have admin controls. This can be
                        changed later on. Please do not create a team account if your organization has an existing team
                        account.
                    </p>
                </>
            )}
            {loading && (
                <div className="flex justify-center items-center h-48">
                    <Loader />
                </div>
            )}
        </div>
    );
};

export default ProfileConfirmation;
